module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/react-scripts/~/babel-runtime/regenerator/index.js
// module id = 988
// module chunks = 0